import { ProjectStatus } from '../../../../responses/projects'

export const archiveStatusFilters: ProjectStatus[] = [
    ProjectStatus.TO_ARCHIVE,
    ProjectStatus.ARCHIVED,
    ProjectStatus.RESERVED,
    ProjectStatus.CLOSED
]